import script from "./manageapi.vue?vue&type=script&setup=true&lang=js"
export * from "./manageapi.vue?vue&type=script&setup=true&lang=js"

import "./manageapi.vue?vue&type=style&index=0&id=07b1720c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b1720c"]])

export default __exports__